import reactDom from 'react-dom';
import CategoryChangeModel from './categoryChangeModel'
import { useEffect, useState, useRef } from 'react';
import{ ArrowLeftOutlined }from '@ant-design/icons';
import './service-list.css';
import { connect } from 'react-redux';
import { fetchFullService } from '../../../../actions';
import SubcategoryHeader from './SubcategoryHeader'
import ServiceContent from './ServiceContent';
import cart_image from '../../../../images/cart.svg';
import { Link } from 'react-router-dom';
import ServiceCategoryUnavailable from './ServiceCategoryUnavailable'
const ServiceList = ({ category, active, setActive, reference, fetchFullService, subcategorys, mobileNav, cartCount, searchParam, recommended }) => {
    const [categoryChangeModelActive, setCategoryChangeModelActive] = useState(false)
    const [modelHeaderText, setModelHeaderText] = useState("Category Changed From")
    const [replacementCartItem, setReplacementCartItem] = useState(null)
    const incrementReplacedService = useRef()
    // const scrollSearchedSubcategory = (callback) => {
        
    // }
    useEffect(() => {
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "auto";
        }   
    }, [])

    useEffect(() => {
        fetchFullService(category)
    }, [fetchFullService, category])

    const closeCategoryModel = () => {
        setCategoryChangeModelActive(false)
    }
    const openCategoryModel = () => {
        setCategoryChangeModelActive(true)
        
    }

    return reactDom.createPortal(
        <div className="service-list-model__main" ref={reference} style={{left: active ? '0%' : '100%'}}>
            <CategoryChangeModel modelActive={categoryChangeModelActive} closeModel={closeCategoryModel} header={modelHeaderText} category={category} replacementItem={replacementCartItem} incrementReplacedService={incrementReplacedService}/>
            <div className="service-list-main-header">
                    <div className="service-list-close" onClick={() => setActive(!active)}><ArrowLeftOutlined style={{fontSize: "20px"}}/></div>
                    <div className="service-list-title">{category[0].toUpperCase() + category.slice(1)}</div>
                    <Link className="cart-icon-container" to="/cart">
                        <img src={cart_image} alt="cart" className="cart-icon" />
                        <div className="cart-count" style={{padding: cartCount > 9 ? "0 3px 0 3px" : "0 5px 0 5px"}}>{cartCount || 0}</div>
                    </Link>
            </div>
            <div className={`${mobileNav ? "" : "ui container"} service-list-model`} style={{display: subcategorys.length === 0 ? "block" : "grid"}}>
                {subcategorys.length > 0 ? <SubcategoryHeader data={subcategorys} searchParam={searchParam} /> : <ServiceCategoryUnavailable category={category}/>}
                {subcategorys.length > 0 ? <ServiceContent category={category} openCategoryModel={openCategoryModel} setModelText={setModelHeaderText} setReplacementCartItem={setReplacementCartItem} incrementReplacedService={incrementReplacedService} recommended={recommended}/> : ""}
            </div>
        </div>,
        document.getElementById('service-list')
    )
}
const mapStateToProps = (state) => {
    let cartCount = 0;
    Array.from(Object.values(state.basicCart)).forEach(x => {
        cartCount += x.quantity
    })
    return {
        subcategorys: state.allServices.subcategory,
        mobileNav: state.mobileNav,
        cartCount: cartCount
    }
}
export default connect(mapStateToProps, { fetchFullService })(ServiceList)